import { Component, OnInit } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {AuthService} from "../../../services/auth/auth.service";
import {ActivatedRoute, Router} from "@angular/router";

@Component({
  selector: 'app-recovery',
  templateUrl: './recovery.component.html',
  styleUrls: ['./recovery.component.scss']
})
export class RecoveryComponent implements OnInit {

  recoveryForm: FormGroup;
  submitted: boolean = false;
  email: string;
  token: string;

  constructor(
    private formBuilder: FormBuilder,
    private auth: AuthService,
    private router: Router,
    private route: ActivatedRoute
  ) {
  }

  onSubmit() {
    this.submitted = true;

    if (this.recoveryForm.invalid) {
      return;
    }

    this.auth.doPasswordRecovery(this.email, this.token, this.recoveryForm.controls.password.value)
      .subscribe(
        () => this.router.navigate(['/']),
        error => alert(error.error.error))
    ;
  }

  ngOnInit() {
    this.route.queryParams.subscribe(q => {
      if (!q.e || !q.t) {
        this.router.navigateByUrl('/login').catch(console.error);
      }
      this.email = q.e;
      this.token = q.t;
    })

    this.recoveryForm = this.formBuilder.group({
      password: ['', Validators.required] // todo: char requirements
    })
  }
}
